import { Autocomplete, AutocompleteChangeDetails, TextField } from '@mui/material';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import BaseResponse from '../../app/BaseResponse';
import Utility from '../../app/utility';
import { SurveyorSelectorSelector, setSurveyorSelectorSearchResults } from './reducers/SurveyorSelectorReducer';
import SurveyorApi from '../Surveyor/api/SurveyorApi';
import SurveyorModel from '../Surveyor/models/SurveyorModel';

interface SurveyorSelectorProps {
    selectedSurveyorId: string | null,
    currentSurveyorName?: string,
    label: string,
    useFocusMode?: boolean,
    focusValue?: number,
    className?: string,
    error?: boolean,
    disable?: boolean,
    onChange?: (value: SurveyorModel | null) => void,
}


const SurveyorSelector: React.FunctionComponent<SurveyorSelectorProps> = (props) => {
    const dispatch = useDispatch();
    const SurveyorSelectorData = useSelector(SurveyorSelectorSelector);
    const textboxRef = React.createRef<HTMLInputElement>();

    useEffect(() => {
        if (SurveyorSelectorData.searchResults.length > 0) {
            return;
        }

        SurveyorApi.GetAll()
            .then((response: BaseResponse<SurveyorModel[]>) => {
                if (response.success) {
                    dispatch(setSurveyorSelectorSearchResults(response.data))
                } else {
                    Utility.Alert.Error(response.message);
                }
            }).catch((error) => {
                Utility.Alert.Error(error);
            })
    }, [])

    let getById = (SurveyorId: string | null) => {
        if (SurveyorId == null) {
            return null;
        }
        let selectedItem = _.find(SurveyorSelectorData.searchResults, (item) => {
            return item.id == SurveyorId;
        })

        return selectedItem;
    }


    useEffect(() => {
        if (props.useFocusMode === true) {
            textboxRef.current?.focus();
        }
    }, [props.focusValue])

    return (
        <>
            {
                SurveyorSelectorData.searchResults.length > 0 &&
                <Autocomplete
                    fullWidth
                    disabled={props.disable}
                    className={props.className ? props.className : ""}
                    value={getById(props.selectedSurveyorId)}
                    options={SurveyorSelectorData.searchResults}
                    renderInput={(params) => <TextField {...params} label={props.label} inputRef={textboxRef} error={props.error} />}
                    getOptionLabel={(option: SurveyorModel) => {
                        return option.name;
                    }}
                    onChange={(event: React.SyntheticEvent, value: SurveyorModel | null, reason: string, details?: AutocompleteChangeDetails<SurveyorModel> | undefined) => {
                        if (props.onChange) {
                            props.onChange(value);
                        }
                    }}
                />
            }
        </>
    )
};

export default SurveyorSelector;